export default function validarDataNascimento(dataStr) {
  // 1️⃣ Valida formato DD/MM/YYYY
  if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(dataStr)) {
    return { valido: false, erro: 'Formato inválido' };
  }

  const [_, dd, mm, yyyy] = dataStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

  const dia = Number(dd);
  const mes = Number(mm) - 1; // JS começa em 0
  const ano = Number(yyyy);

  // 2️⃣ Cria a data e valida se ela existe
  const data = new Date(ano, mes, dia);

  if (
    data.getFullYear() !== ano ||
    data.getMonth() !== mes ||
    data.getDate() !== dia
  ) {
    return { valido: false, erro: 'Data inexistente' };
  }

  // 3️⃣ Calcula idade
  const hoje = new Date();
  let idade = hoje.getFullYear() - ano;

  const fezAniversarioEsteAno =
    hoje.getMonth() > mes ||
    (hoje.getMonth() === mes && hoje.getDate() >= dia);

  if (!fezAniversarioEsteAno) idade--;

  // 4️⃣ Regras de idade
  if (idade < 18) {
    return { valido: false, erro: 'Menor de 18 anos' };
  }

  if (idade > 100) {
    return { valido: false, erro: 'Idade superior a 100 anos' };
  }

  return { valido: true, idade };
}